module.exports = __webpack_public_path__ + "img/main.25142ba7.svg";